import React from "react"
import { useContact } from "../../stores/useContactStore"
import { useWebSocketChatContext } from "../../contexts/webSocketChatContext"
import { getProfileUserById } from "../../utils/utils"
import { useData } from "../../contexts/dataContext"
import ImageWithFallback from "../ImageWithFallback"

const defaultPicture = "https://oktto-model.s3.us-east-1.amazonaws.com/files/default_profile_picture.png"

const ProfileImageByMessage = ({ message, platform }) => {
    const { allUsersGroup } = useData()
    const { getContactByContactDataAndPlatform } = useWebSocketChatContext()

    const contact = useContact(message.contact_id) || {}

    const getUserProfileSender = (user_id) => {
        let user = { name: message?.is_bot ? "Você (Bot AI)" : "Você (Envio externo)" }
        if (user_id) {
            user = getProfileUserById(allUsersGroup, user_id)
        }
        return user
    }

    if (message.direction === "send") {
        const user = getUserProfileSender(
            message.user_id,
            message?.bot_details?.is_bot
        )

        return user?.image || (<img src={defaultPicture} alt="Imagem de Perfil" />)
    }

    const contactData = getContactByContactDataAndPlatform(contact, platform)

    return contactData?.picture ? (
        <ImageWithFallback
            src={contactData.picture}
            alt="Imagem de Perfil"
            functionError={() => (
                <img src={defaultPicture} alt="Imagem de Perfil" />
            )}
        />
    ) : (
        <img src={defaultPicture} alt="Imagem de Perfil" />
    )
}

export default ProfileImageByMessage